import { useQuery } from 'react-query';
import { AnchorAPI } from 'client/modules/AnchorAPI';

const USE_GEO_REGION_KEY = 'getGeoRegion';

function useGeoRegion() {
  const { data: geoRegionData, status, refetch } = useQuery(
    [USE_GEO_REGION_KEY],
    () => AnchorAPI.getGeoRegion()
  );

  return {
    geoRegionData,
    status,
    refetch,
  };
}

export { useGeoRegion };
